import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ScrollBanner = ({slidersFavourite}) => {
  const [isLoggedIn] = useState(!!localStorage.getItem('token'));
  const navigate = useNavigate();
  
  const exchangeToken = localStorage.getItem('exchangeToken');

  // ✅ Fixed: use React Router navigate() instead of window.location.href
  const handleNavigation = (link) => {
    if (isLoggedIn) {
      if (link) {
        // External exchange URL — window.location is appropriate for cross-origin
        window.location.href = `https://tech.betskyexch.com/m/#/token/${exchangeToken}`;
      }
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="recommend scroll-banner">
      <div className="recommend-title">
        <h2>Favourites</h2>
      </div>
      <div className="recommend-bg">
        <div className="recommend-main">
          {slidersFavourite.length > 0 ? (
            slidersFavourite.map((slider, index) => (
              <div className="recommend-card" key={index} onClick={() => handleNavigation(slider.link)}>
               <Link>
               <img
                  alt={`slider_image_${index}`}
                  src={`${process.env.REACT_APP_API_URL}/storage/${slider.thubmnail}`}
                  loading="lazy"
                  style={{ cursor: 'pointer' }} // Change the cursor to pointer for better UX
                />
               </Link>
              </div>
            ))
          ) : (
            <p></p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScrollBanner;
